var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error && _vm.error.length)?_c('section',{staticClass:"vuw-error vuw-text-second-1"},[_c('i',{staticClass:"fas fa-exclamation-circle vuw-mr-2"}),_c('span',{staticClass:"vuw-text-small"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }